import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@components/webdesktop/elements/Checkbox/Checkbox';
import { FormLabel } from '@components/webdesktop/elements/FormLabel/FormLabel';
import { Button } from './Button';
import { LookupDropDownForm } from './LookupDropDownForm';
import { LookupDropDownDefaults } from '../../UtilsClasses/LookupDropDownDefaults';
import { AccountLookupDropDownFormViewModel } from '../../ViewModels/AccountLookupDropDownFormViewModel';
export class AccountLookupDropDownForm extends LookupDropDownForm {
    constructor(props) {
        super(props, AccountLookupDropDownFormViewModel);
        this.onCheckAllStateChange = (event) => {
            this.viewModel.onCheckAllStateChange(event.currentTarget.checked);
        };
        this.onAddBtnClick = this.onAddBtnClick.bind(this);
        this.onCancelBtnClick = this.onCancelBtnClick.bind(this);
    }
    onAddBtnClick() {
        this.viewModel.onAddBtnClicked(true);
    }
    onCancelBtnClick() {
        this.viewModel.close();
    }
    renderDropDownForm() {
        return (_jsxs("div", { className: "accountLookupDropDownForm", children: [_jsxs("div", { className: "header_acc_lookupDropDownForm", children: [this.renderTextBox('textBox_acc_lookupDropDownForm'), _jsx("div", { className: "account-lookup-header-filter", children: this.renderMultiSelectCheckbox() })] }), _jsx("div", { className: "body_acc_lookupDropDownForm", children: this.renderQuickTree() }), this.renderFooter()] }));
    }
    renderFooter() {
        if (!this.viewModel.isShowFooterBtn()) {
            return null;
        }
        const { selectAllText, checkedSelectedAll, enabledAddBtn, addBtnText, cancelBtnText } = this.state;
        return (_jsxs("div", { className: "footer_acc_lookupDropDownForm", children: [_jsx("div", { className: "checkBoxContainer_acc_lookupDropDownForm", children: _jsx(FormLabel, { label: selectAllText, children: _jsx(Checkbox, { checked: checkedSelectedAll, onChange: this.onCheckAllStateChange }) }) }), _jsxs("div", { className: "addCancelBtnContainer_acc_lookupDropDownForm", children: [_jsx(Button, { text: addBtnText, buttonStyle: "js-button-ok style-width-100", enabled: enabledAddBtn, onClick: this.onAddBtnClick }), _jsx(Button, { text: cancelBtnText, buttonStyle: "js-button-gray25 style-width-100", onClick: this.onCancelBtnClick })] })] }));
    }
}
AccountLookupDropDownForm.defaultProps = {
    width: LookupDropDownDefaults.width,
    height: LookupDropDownDefaults.height
};
